import '@fontsource-variable/inter-tight';
import 'ol/ol.css';
import 'react-toastify/dist/ReactToastify.css';
import {Client as AuthClient} from '@apps-common/auth';
import {AuthProvider} from '@apps-common/auth-react';
import {DocumentHandler} from '@apps-common/auth-utils';
import {DARK_THEME} from '@apps-common/ui-theme/Themes.js';
import {CssBaseline, ThemeProvider} from '@mui/material';
import {asyncWithLDProvider} from 'launchdarkly-react-client-sdk';
import React from 'react';
import {createRoot} from 'react-dom/client';
import {Provider} from 'react-redux';
import {Slide, ToastContainer} from 'react-toastify';
import App from './components/app.jsx';
import {LD_CLIENTSIDE_ID} from './config.js';
import initSentry from './sentry.js';
import store from './store.js';
import appGlobalStyles from './styles/AppGlobalStyles.jsx';

if (window.location.hostname === 'www.planet.com') {
  initSentry();
}

const authClient = new AuthClient({
  clientId:
    import.meta.env.VITE_OIDC_CLIENT_ID || 'cn6p3eh2eekTj6oS2qOeVUF9Jx0vI9Dz',
  redirectUri: `${window.location.origin}${window.location.pathname}`,
});

function navigate(rel) {
  // just update the hash back instead of window.location.replace to avoid a page refresh
  const hash = rel?.split('#') || [];
  window.location.hash = hash[1] ?? '';
}

const container = document.getElementById('root');

const root = createRoot(container);

(async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: LD_CLIENTSIDE_ID,
  });

  root.render(
    <AuthProvider client={authClient} navigate={navigate} private>
      <Provider store={store}>
        <LDProvider>
          <ThemeProvider defaultMode="dark" theme={DARK_THEME}>
            <CssBaseline />
            {appGlobalStyles}
            <DocumentHandler>
              <ToastContainer
                transition={Slide}
                position="top-center"
                theme="colored"
                hideProgressBar
              />
              <App />
            </DocumentHandler>
          </ThemeProvider>
        </LDProvider>
      </Provider>
    </AuthProvider>,
  );
})();
